import {configureStore} from '@reduxjs/toolkit';

import projectReducer from './redux/projectSlice';

 const Store = configureStore({
  reducer :{
        projects :projectReducer,
        
  }
});
export default Store;